moduleViewApp.controller('historyCtrl', ['$scope', '$routeParams', 'ItemsResource', 'ChangesResource', ($scope, $routeParams, ItemsResource, ChangesResource) ->
  #debug
  window.debug = window.debug || {}
  window.debug["historyCtrl"] = $scope

  _.assignIn $scope,
    dirty: true
    changes: []
    itemMap:
      Item: {}
      Concept: {}
      Facet: {}
      Annotation: {}
      Sentence: {}

    editLink: (change) ->
      return null if change.update_type == "destroy"
      map = $scope.itemMap[change.target_type]
      if map && map[change.target_id]
        ids = map[change.target_id]
        if ids.annotation_id
          Packs.iKnowRoutes.v3_create_set_item_notes_path($routeParams.set_id, ids.item_id)
        else
          Packs.iKnowRoutes.edit_v3_create_set_item_path($routeParams.set_id, ids.item_id)
      else
        null

  ItemsResource.query {
    set_id: $routeParams.set_id
  }, (success) ->
    for item in success.response
      $scope.itemMap.Item[item.id] =
        item_id: item.id
      for facet in item[item.template_type].facets
        $scope.itemMap.Facet[facet.id] =
          item_id: item.id
          facet_id: facet.id
        if facet.anchor.concept
          $scope.itemMap.Concept[facet.anchor.concept.id] =
            item_id: item.id
            facet_id: facet.id
        if facet.association.concept
          $scope.itemMap.Concept[facet.association.concept.id] =
            item_id: item.id
            facet_id: facet.id
      for sentence in [].concat(item.sentences)
        $scope.itemMap.Sentence[sentence.id] =
          item_id: item.id
          sentence_id: sentence.id
      for annotation in [].concat(item.annotations)
        $scope.itemMap.Annotation[annotation.id] =
          item_id: item.id
          annotation_id: annotation.id

    ChangesResource.query {
      set_id: $routeParams.set_id
    }, (success) ->
      $scope.dirty = false
      $scope.changes = success.response
      for change in $scope.changes
        change.url = $scope.editLink(change)
])
